import { ImportExport } from "@mui/icons-material";
import {
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { DEFAULT_ELEVATION } from "lib/global";
import { useEffect, useState } from "react";
import EditFormControl from "./form/EditFormControl";

export const COUNT_PER_PAGE = 8;

export default function CustomTable({
  data = [],
  // label, selector, cell, sortable: 'no',cellCSS, align, type: 'date' | 'number'
  columns = [],
  selected = {},
  stickyHeader = true,
  height = 450,
  isFixed = true,
  className = "",
  defaultSortKeyIndex = -1,
  defaultASC = true,
  toolbar = false,
  pageCount = COUNT_PER_PAGE,
  isPageActive = false,
  onChangePage = () => {},
  onSortKey = () => {},
  page = 0,
  totalPage = 0,

  noHeader = false,
  size = "small",

  checkAll = false,

  textColor = "secondary",

  elevation = DEFAULT_ELEVATION,
  onSelect = () => {},
  onContextMenu = () => {},
  onSelectAll = () => {},
  ...props
}) {
  const [sortKey, setSortKey] = useState(
    defaultSortKeyIndex >= 0
      ? {
          index: defaultSortKeyIndex,
          column: columns?.[defaultSortKeyIndex] ?? {},
          asc: Boolean(defaultASC),
        }
      : {
          index: -1,
        }
  );
  const [current, setCurrent] = useState(data);
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: data?.length,
  });

  const isPage = pagination.pageCount > 1;
  const pagedData =
    isPage && !isPageActive
      ? current.slice(
          (pagination.page - 1) * pageCount,
          pagination.page * pageCount
        )
      : current;

  const handlePage = (e, v) => {
    if (isPageActive) {
      onChangePage(v, sortKey);
    } else {
      setPagination((s = {}) => ({ ...(s ?? {}), page: v }));
    }
  };

  const handleSortKey = (columnIndex = 0, column = {}) => {
    setSortKey((s = {}) => ({
      index: columnIndex,
      column: column,
      asc: s?.index === columnIndex ? !Boolean(s?.asc ?? false) : false,
    }));
  };

  const handleSort = (a, b) => {
    const aValue = sortKey?.column?.sortValue
      ? sortKey?.column?.sortValue(a)
      : a?.[sortKey?.column?.selector ?? ""];
    const bValue = sortKey?.column?.sortValue
      ? sortKey?.column?.sortValue(b)
      : b?.[sortKey?.column?.selector ?? ""];
    const formattedValue = {
      a: aValue,
      b: bValue,
    };
    if (Boolean(sortKey?.asc)) {
      return formattedValue.a > formattedValue.b ? -1 : 1;
    } else {
      return formattedValue.a < formattedValue.b ? -1 : 1;
    }
  };

  useEffect(() => {
    if (
      (Boolean(data?.length > 0) ||
        (Boolean(data?.length === 0) && Boolean(current?.length > 0))) &&
      !Boolean(sortKey?.column?.sortable === "no")
    ) {
      if (!isPageActive) {
        setCurrent(() => data?.sort(handleSort));
        setPagination({
          page: 1,
          pageCount: Math.ceil(data.length / pageCount),
        });
      } else {
        setCurrent(data);
      }
    }
    // eslint-disable-next-line
  }, [data, sortKey]);

  useEffect(() => {
    if (isPageActive) {
      onSortKey(sortKey);
    }
    // eslint-disable-next-line
  }, [sortKey]);

  useEffect(() => {
    if (isPageActive) {
      setPagination({ page, pageCount: totalPage });
    }
    // eslint-disable-next-line
  }, [page, totalPage, isPageActive]);

  return (
    <div>
      <Paper elevation={elevation}>
        {Boolean(toolbar) && toolbar}
        <TableContainer
          className={`${className} overflow-auto scroll-thumb`}
          style={{
            width: "100%",
            height: height,
          }}
        >
          <Table
            stickyHeader={stickyHeader}
            style={{ width: "100%", cursor: "pointer" }}
            size={size}
            sx={{ minWidth: 700 }}
          >
            {!noHeader && (
              <TableHead>
                <TableRow>
                  {columns.map((column, columnIndex) => (
                    <TableCell
                      className={`py-4 ${
                        column?.selector === "checkbox" && "w-2"
                      }`}
                      key={columnIndex}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                        title={column.label}
                      >
                        {column?.selector === "checkbox" ? (
                          <EditFormControl
                            type="checkbox"
                            value={checkAll}
                            onChange={onSelectAll}
                          />
                        ) : (
                          <span className="text-xs">{column.label}</span>
                        )}

                        {column?.sortable !== "no" &&
                          column?.selector !== "actions" &&
                          column?.selector && (
                            <IconButton
                              size="small"
                              onClick={() => {
                                handleSortKey(columnIndex, column);
                              }}
                            >
                              <ImportExport
                                color={
                                  columnIndex === sortKey?.index
                                    ? sortKey.asc
                                      ? "primary"
                                      : "error"
                                    : "inherit"
                                }
                              />
                            </IconButton>
                          )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            )}
            <TableBody>
              {Boolean(props?.couponTable) && (
                <TableRow>
                  <TableCell colSpan={3} />
                  <TableCell className="text-right">Total</TableCell>
                  <TableCell />
                  <TableCell className="py-2">
                    {data?.reduce((ret, cur) => ret + cur?.count?.id, 0)}
                  </TableCell>
                  <TableCell className="py-2" colSpan={2}>
                    {data?.reduce((ret, cur) => ret + cur?.remain_boxes, 0)}
                  </TableCell>
                </TableRow>
              )}
              {Boolean(pagedData?.length) ? (
                <>
                  {(pagedData ?? []).map((row, index, self) => {
                    return (
                      <TableRow
                        className={
                          Boolean(selected?.id === row?.id) && Boolean(row?.id)
                            ? "bg-primary bg-opacity-30"
                            : ""
                        }
                        key={index}
                        hover
                        onClick={() => {
                          onSelect(row, index);
                        }}
                        onContextMenu={() => {
                          onContextMenu(row, index);
                        }}
                      >
                        {columns.map((column, columnIndex) => (
                          <TableCell
                            key={columnIndex}
                            className={`text-13 text-${textColor} ${
                              column?.cellCSS ?? ""
                            }`}
                            align={column?.align ?? "left"}
                          >
                            {/* <LazyLoad> */}
                            {column?.cell
                              ? column.cell(row, index, self)
                              : row?.[column?.selector ?? ""]}
                            {/* </LazyLoad> */}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })}
                </>
              ) : (
                <TableRow>
                  <TableCell colSpan={columns?.length ?? 1} align="center">
                    <span className="text-13">No Data</span>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {isPage && (
          <div className="py-3 flex justify-center">
            <Pagination
              count={pagination?.pageCount}
              page={pagination?.page}
              onChange={handlePage}
              variant="contained"
              shape="rounded"
              color="primary"
            />
          </div>
        )}
      </Paper>
    </div>
  );
}
